import { connect } from "react-redux"

import { checkCode, resetCode, setCode } from "../store/survey.actions"
import { getId, getIndividualCode, getStatus } from "../store/survey.selectors"

const mapState = state => ({
  individualCode: getIndividualCode(state),
  surveyId: getId(state),
  status: getStatus(state)
})

const mapDispatch = dispatch => ({
  checkCode: payload => dispatch(checkCode(payload)),
  setCode: payload => dispatch(setCode(payload)),
  resetCode: () => dispatch(resetCode())
})

const codeCheckContainer = connect(mapState, mapDispatch)

export default codeCheckContainer
